import firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
}

// Prevent re-initializing on hot reload
if (!firebase.apps.length) {
  firebase.initializeApp(firebaseConfig)
}

// Secondary app instance used exclusively for creating new users
// without affecting the current admin session
if (!firebase.apps.find(app => app.name === 'secondary')) {
  firebase.initializeApp(firebaseConfig, 'secondary')
}

export const auth = firebase.auth()
export const db = firebase.firestore()
export const secondaryAuth = firebase.app('secondary').auth()